import createReducer from '../createReducer'
import { range } from 'shared/lang'
import {
  INIT_PAGINATOR,
  SET_PAGE,
  LOAD_PAGINATED_PAGE_SUCCESS,
  LOAD_PAGINATED_PAGE_LOADING,
  LOAD_PAGINATED_PAGE_ERROR,
} from './constants'

export const initialState = {}

export const initialPageState = {
  offset: 0,
  current: 1,
  pages: 0,
  count: 0,
  first: true,
  last: false,
  firstButtonIndex: 1,
  pageButtons: [],
}

export function getPageButtons (current, max, pages) {
  const supportsWindowing = pages > max + 2
  const count = supportsWindowing ? max : pages
  const mid = max / 2
  const atBeginning = current <= (max - mid)
  const atEnd = current > (pages - max + 1)
  let start

  if (!supportsWindowing || atBeginning) {
    start = 1
  } else if (atEnd) {
    start = pages - max + 1
  } else {
    start = Math.max(Math.round(current - mid), 1)
  }

  return range(start, count)
}

export default createReducer(initialState, {

  name: 'paginator',

  [INIT_PAGINATOR]: (state, action) => {
    const { name, perPage, loadPage, maxPageButtons } = action.payload
    const _maxPageButtons = Math.max(maxPageButtons, 3)
    const pageButtons = getPageButtons(1, _maxPageButtons, 0)

    return {
      ...state,
      [name]: {
        ...initialPageState,
        limit: perPage,
        maxPageButtons: _maxPageButtons,
        loadPage,
        pageButtons,
      },
    }
  },

  [SET_PAGE]: (state, action) => {
    const { payload, meta: { name }} = action
    const slice = state[name]
    const { limit, maxPageButtons: max, pages } = slice
    const pageButtons = getPageButtons(payload, max, pages)
    return {
      ...state,
      [name]: {
        ...slice,
        current: payload,
        offset: limit * (payload - 1),
        pageButtons,
      },
    }
  },

  [LOAD_PAGINATED_PAGE_LOADING]: (state, action) => {
    const { meta: { name }} = action
    return {
      ...state,
      [name]: {
        ...state[name],
        loading: true,
      },
    }
  },

  [LOAD_PAGINATED_PAGE_ERROR]: (state, action) => {
    const { meta: { name }} = action
    return {
      ...state,
      [name]: {
        ...state[name],
        loading: false,
      },
    }
  },

  [LOAD_PAGINATED_PAGE_SUCCESS]: (state, action) => {
    const { meta, payload } = action
    const { results, count } = payload.value
    const { name } = meta
    const { limit, current, maxPageButtons: max } = state[name]
    const pages = Math.ceil(count / limit)
    const pageButtons = getPageButtons(current, max, pages)

    return {
      ...state,
      [name]: {
        ...state[name],
        pages,
        count,
        results,
        loading: false,
        last: current === pages,
        first: current === 1,
        pageButtons,
      },
    }
  },

})
